import React from 'react'
import {Chart, ZoomButtons} from 'react-stockcharts'
import LineSeries from '../LineSeries'
import {XAxis, YAxis} from 'react-stockcharts/lib/axes'
import {
  MouseCoordinateX,
  CurrentCoordinate
} from 'react-stockcharts/lib/coordinates'
import {SingleValueTooltip} from 'react-stockcharts/lib/tooltip'
import {Label} from 'react-stockcharts/lib/annotation'
import {timeFormat} from 'd3-time-format'

import {format} from '../functions'

export const getPnlChart = (width, margin, yExtents, origin, reset, frequency, mouseCoordinateWidth, nextFailed) => (
  <Chart
    id='pnl'
    yExtents={yExtents}
    height={250}
    origin={origin}
  >
    <ZoomButtons onReset={reset}/>
    <rect
      width={width - margin.left - margin.right}
      x={1}
      height={250}
      stroke='#000000'
      strokeOpacity={0.3}
      strokeWidth={1}
      fill='rgba(80,80,255,0.1)'
    />
    <SingleValueTooltip
      yLabel={'PnL'}
      valueFill='black'
      fontSize={12}
      labelFill={'rgb(31, 119, 180)'}
      yAccessor={d => d.pnl}
      origin={[20, 20]}
      yDisplayFormat={format('$')}
    />
    <Label
      x={(width - margin.left - margin.right)/2}
      y={20}
      fontSize={16}
      text='PnL'
    />
    <XAxis
      axisAt='bottom'
      orient='bottom'
      opacity={0}
      tickStrokeOpacity={0.1}
      innerTickSize={-250}
      fontSize={0}
    />
    <YAxis
      axisAt='left'
      orient='left'
      ticks={6}
      tickFormat={format('$')}
      tickStrokeOpacity={0.1}
      innerTickSize={-(width - margin.left - margin.right)}
    />
    {nextFailed &&
      <MouseCoordinateX
        at='bottom'
        orient='bottom'
        displayFormat={timeFormat(frequency)}
        rectWidth={mouseCoordinateWidth}
      />
    }

    <LineSeries
      yAccessor={d => d.pnl}
      stroke='rgb(31, 119, 180)'
      strokeWidth={2}
      connectNulls={true}
      target='pnl'
    />

    <CurrentCoordinate yAccessor={d => d.pnl} fill='rgb(31, 119, 180)'/>

  </Chart>
)
